/**
 * i18n Configuration
 * Multi-Language Support nach SAMEBI-Pattern
 */

import type { Language } from '@/core/config/language-v2';

export interface TranslationFunction {
  (key: string): string;
  (key: string, params: Record<string, string | number>): string;
}

export interface I18nContext {
  language: Language;
  t: TranslationFunction;
}

/**
 * Replace placeholders in translation strings
 * Example: "Hello {{name}}" with {name: "John"} => "Hello John"
 */
export const interpolate = (
  template: string,
  params?: Record<string, string | number>
): string => {
  if (!params) return template;
  
  return Object.entries(params).reduce(
    (result, [key, value]) => 
      result.replace(new RegExp(`{{${key}}}`, 'g'), String(value)),
    template
  );
};

/**
 * Get nested translation by dot notation
 * Example: "meta.title" => translations.meta.title
 */
export const getNestedValue = (
  obj: Record<string, unknown>,
  path: string
): string => {
  const keys = path.split('.');
  let value: unknown = obj;
  
  for (const key of keys) {
    if (value && typeof value === 'object' && key in value) {
      value = (value as Record<string, unknown>)[key];
    } else {
      console.warn(`Translation key not found: ${path}`);
      return path; // Return key as fallback
    }
  }
  
  return typeof value === 'string' ? value : path;
};


